import { render, staticRenderFns } from "./ServeOrderDisable.vue?vue&type=template&id=61315424&scoped=true&"
import script from "./ServeOrderDisable.vue?vue&type=script&lang=js&"
export * from "./ServeOrderDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61315424",
  null
  
)

export default component.exports